<template>
  <SectionContainer class="fluid-x" v-if="isVisible">
    <SectionHeader>
      <template #title>
        <b>Cursos exclusivos</b>
      </template>
      
      <template #subtitle>
        Conteúdo exclusivo para sua assinatura
      </template>
    </SectionHeader>

    <HorizontalCarousel :items="courses">
      <template v-slot="{ item }">
        <CourseThumbBox
          :course="item"
          class="course-thumb-box"
        />
      </template>
    </HorizontalCarousel>
  </SectionContainer>
</template>

<script>
  import SectionContainer from '@/components/layout/SectionContainer'
  import SectionHeader from '@/components/layout/SectionHeader'
  import CourseThumbBox from '@/components/course/CourseThumbBox'
  import HorizontalCarousel from '@/components/carousel/HorizontalCarousel'
  import { getPremiumCourses } from '@/api/course.api'

  export default {
    components: {
      SectionContainer,
      SectionHeader,
      CourseThumbBox,
      HorizontalCarousel,
    },

    data: () => ({
      courses: [],
    }),

    async mounted () {
      try {
        const res = await getPremiumCourses()
        this.courses = res.data
      } catch (err) { }
    },

    computed: {
      isVisible () {
        return this.courses.length > 0
      }
    }
  }
</script>